import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Film, BarChart3, Clock, Headphones, HelpCircle } from "lucide-react";

const links = [
  { to: "/", label: "HOME", icon: Film, testid: "nav-home" },
  { to: "/stats", label: "STATS", icon: BarChart3, testid: "nav-stats" },
  { to: "/time-machine", label: "TIME MACHINE", icon: Clock, testid: "nav-time-machine" },
];

export const Navbar = ({ onHowToPlay }) => {
  const loc = useLocation();
  return (
    <header className="sticky top-0 z-50 ac-glass" data-testid="main-navbar">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-link">
          <Film className="w-6 h-6 ac-gold-text group-hover:rotate-12 transition-transform" />
          <span className="font-display text-lg sm:text-2xl font-black tracking-widest ac-gold-text leading-none">
            ABSOLUTE CINEMA
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          {links.map((l) => {
            const active = loc.pathname === l.to;
            const Icon = l.icon;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                title={l.label}
                className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-lg text-xs font-bold tracking-wide transition-all ${
                  active
                    ? "bg-amber-500/15 text-amber-300 border border-amber-500/30"
                    : "text-zinc-400 hover:text-amber-200 hover:bg-white/5"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden md:inline">{l.label}</span>
              </Link>
            );
          })}
          <button
            onClick={onHowToPlay}
            data-testid="nav-how-to-play"
            title="How to Play"
            className="flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-lg text-xs font-bold text-zinc-400 hover:text-amber-200 hover:bg-white/5 transition-all"
          >
            <HelpCircle className="w-4 h-4" />
            <span className="hidden md:inline">HOW TO PLAY</span>
          </button>
        </nav>
      </div>
    </header>
  );
};
